import React, { useState } from 'react';
import { toJS } from 'mobx';
import { observer } from 'mobx-react-lite';
import { Button } from '@insurancemenu/imenu-components-lib';
import { Add } from '@insurancemenu/imenu-components-lib/dist/icons';
import { DDARCustomUser } from 'types/formService';
import { useRootStore } from 'store/rootStore';
import UserModal from 'components/common/form/custom/AuthorizedUsers/UserModal';
import UsersTable from '../UsersTable';
import { createStyles } from './styles';

const UsersBlock: React.FC = observer(() => {
  // Mobx store
  const { customAuthorizedUserStore, webFormStore } = useRootStore();

  const usersFromStore = webFormStore.dynamicForm?.customFields.authorizedUsers;

  const addedUsers: DDARCustomUser[] = !usersFromStore?.value
    ? []
    : usersFromStore.value?.map((user) => toJS(user)).slice() || [];

  // React state
  const [showUserModal, setShowUserModal] = useState(false);
  const [userModalMode, setUserModalMode] = useState<'ADD' | 'EDIT'>('ADD');

  // Component actions
  function openUserModal(): void {
    setShowUserModal(true);
  }

  function closeUserModal(): void {
    setShowUserModal(false);
  }

  function onAddUser(): void {
    customAuthorizedUserStore.setActiveUserId(undefined);
    customAuthorizedUserStore.form.resetForm();
    setUserModalMode('ADD');
    openUserModal();
  }

  function onEditUser(user: DDARCustomUser): void {
    customAuthorizedUserStore.setActiveUserId(user.id);
    customAuthorizedUserStore.form.populateFields(user);
    setUserModalMode('EDIT');
    openUserModal();
  }

  function onDeleteUser(idToDelete: number): void {
    webFormStore.dynamicForm?.customFields.authorizedUsers.updateValue(
      webFormStore.dynamicForm.customFields.authorizedUsers.value.filter((user) => user.id !== idToDelete),
    );
  }

  function onSaveUser(): void {
    if (userModalMode === 'ADD') {
      const newUser: DDARCustomUser = {
        id: addedUsers.length,
        ...customAuthorizedUserStore.form.getFormDataObject(),
      } as DDARCustomUser;
      webFormStore.dynamicForm?.customFields.authorizedUsers.updateValue([...addedUsers, newUser]);
    } else {
      const userUnderUpdate = addedUsers.find(
        (depObj: DDARCustomUser) => depObj.id === customAuthorizedUserStore.activeUserId,
      );
      const indexOfUserUnderUpdate = userUnderUpdate && addedUsers.indexOf(userUnderUpdate);
      const newAddedUsers = [...addedUsers];
      if (userUnderUpdate && indexOfUserUnderUpdate !== undefined) {
        newAddedUsers[indexOfUserUnderUpdate] = {
          ...customAuthorizedUserStore.form.getFormDataObject(),
          id: userUnderUpdate.id,
        } as DDARCustomUser;
        webFormStore.dynamicForm?.customFields.authorizedUsers.updateValue([...newAddedUsers]);
      }
    }
    closeUserModal();
  }

  const classes = createStyles();
  return (
    <div className={classes.usersWrapper}>
      <Button leftIconProp={<Add />} color="primary" size="large" onClick={onAddUser}>
        Add Authorized User
      </Button>
      {addedUsers?.length > 0 && <UsersTable users={addedUsers} onEditUser={onEditUser} onDeleteUser={onDeleteUser} />}
      <UserModal show={showUserModal} onClose={closeUserModal} onAction={onSaveUser} mode={userModalMode} />
    </div>
  );
});

export default UsersBlock;
